import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import be from "../../BE";
import auth from "../../Account/Auth";

function SearchContacts({ setStage }) {
  const { t } = useTranslation(["onboarding"]);
  const history = useHistory();

  const saveIntent = async (_intent) => {
    const body = {
      intent: _intent,
    };

    try {
      await auth
        .isAuthenticated()
        .then(() => {
          be.post("Onboarding", "/onboarding/leads", body, true, true)
            .then((response) => {
              console.log(
                "[onboarding][search-contacts-intent] search-contacts-intent saved"
              );
            })
            .catch((error) => {
              console.error(
                "[onboarding][search-contacts-intent] network error while saving search-contacts-intent:",
                error
              );
            });
        })
        .catch((error) => {
          console.error(
            "[onboarding][search-contacts-intent] authentication error while saving search-contacts-intent:",
            error
          );
          history.push({ pathname: "/login" });
        });
    } catch (error) {
      console.error(
        "[onboarding][search-contacts-intent] functional error while saving search-contacts-intent:",
        error
      );
    } finally {
      setStage("notifications");
    }
  };

  return (
    <>
      <h1 className="tw-mb-4 tw-text-2xl tw-font-extrabold tw-leading-tight tw-tracking-tight tw-text-gray-900 sm:tw-mb-6 tw-dark:text-white">
        Search Contacts: a new Feature will be available soon!
      </h1>

      <p className="tw-my-4 tw-text-lg tw-font-light tw-text-gray-500 tw-dark:text-gray-400">
        Will you be using it?
      </p>
      <div className="tw-mx-auto tw-max-w-[300px] tw-my-10 tw-flex">
        <img
          src="img/search-contacts-animation.gif"
          alt="calendbook-search-contacts"
          className="tw-rounded-3xl tw-border-solid tw-border-gray-300 tw-border"
        />
      </div>
      <ul className="tw-mb-6 tw-gap-6 tw-w-full tw-inline-flex tw-justify-center">
        <li>
          <input
            type="radio"
            id="no"
            name="interest"
            value="no"
            className="!tw-hidden tw-peer"
            required
          />
          <label
            onClick={() => {
              saveIntent(false);
            }}
            htmlFor="no"
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-auto tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-dark:hover:text-gray-300 tw-dark:border-gray-700 tw-dark:peer-checked:text-primary-500 peer-checked:tw-border-primary-600 peer-checked:tw-text-primary-600 tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700"
          >
            <span className="tw-w-full">Not very interested</span>
          </label>
        </li>
        <li>
          <input
            type="radio"
            id="yes"
            name="interest"
            value="yes"
            className="!tw-hidden tw-peer"
          />
          <label
            onClick={() => {
              saveIntent(true);
            }}
            htmlFor="yes"
            className="tw-inline-flex tw-items-center tw-justify-center tw-w-auto tw-p-5 tw-text-gray-500 tw-border-2 tw-border-gray-200 tw-rounded-lg tw-cursor-pointer tw-dark:hover:text-gray-300 tw-dark:border-gray-700 tw-dark:peer-checked:text-primary-500 peer-checked:tw-border-primary-600 peer-checked:tw-text-primary-600 tw-bg-gray-50 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-dark:text-gray-400 tw-dark:bg-gray-800 tw-dark:hover:bg-gray-700"
          >
            <span className="tw-w-full">I was waiting for it!</span>
          </label>
        </li>
      </ul>
    </>
  );
}

export default SearchContacts;
